<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" style="width:520px"
          label-width="120px" class="detail-form">
          <el-form-item class="detail-from-input" label="车辆品牌名称" prop="vehicleBrand">
            <el-select class="full-width" size="small" v-model="detailForm.vehicleBrand" clearable placeholder="请选择">
              <el-option v-for="v in brandList" :key="v.id" :label="v.vehicleBrand" :value="v.vehicleBrand"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="detail-from-input" label="车辆型号名称" prop="vehicleModel">
            <el-input v-model="detailForm.vehicleModel" size="small"></el-input>
          </el-form-item>
          <el-form-item class="detail-from-input" label="备注">
            <el-input v-model="detailForm.remark" size="small"></el-input>
          </el-form-item>
          <el-form-item class="detail-from-input detail-body-title" label="状态" prop="invokeFlag">
            <el-radio-group v-model="detailForm.invokeFlag">
              <el-radio label="Y">启用</el-radio>
              <el-radio label="N">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class=" flex-r-end">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: false,
      pageTitle: '车辆型号新增',
      // 默认值设置
      detailForm: {
        invokeFlag: 'Y', // 新增默认启用
      },
      hideUpload: false,//上传图片按钮
      imageUrl: "",//图片储存
      dialogImageUrl: null,//图片地址
      dialogVisible: false,

      chargingSpeed: [], // 充电速度
      chargingType: [], // 电流输出类型
      interfaceType: [], // 接口类型 
      businessBelongList: [], // 业务归属
      useStateList: [], // 系统状态
      warrantyTimeList: [], // 质保有效期
      networkTimeList: [], // 联网订阅
      phaseList: [], // 单相桩、三相桩
      audioFrequencyList: [], // 音频
      brandList: [], // 联网方式

    }
  },
  created() {
    this.init()
  },
  methods: {

    //判断是否为编辑模式
    init() {
      let _ = this;
      if (_.$store.state.editId) {
        _.editFlag = true;
        _.pageTitle = '车辆型号编辑';
        const modelInfo = _.$route.query.modelInfo;
        _.detailForm = modelInfo ? { ..._.detailForm, ...modelInfo } : _.detailForm;
      }
      this.getBrandList()
    },
    getBrandList() {
      let _ = this
      _.$H.post(_, _.$A.digitization.vehicleBrandAll, { status: '01' }).then(res => {
        if (res.status === 200) {
          _.brandList = res.data.data
        }
      })
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_.editFlag) {
            _.$H.post(_, _.$A.digitization.vehicleModelEdit, _.detailForm).then(res => {
              if (res.status === 200) {
                _.$router.push({
                  name: pageConfig.listRouter
                });
              }
            })
          } else {
            _.$H.post(_, _.$A.digitization.vehicleModelAdd, _.detailForm).then(res => {
              if (res.status === 200) {
                _.$router.push({
                  name: pageConfig.listRouter
                });
              }
            })
          }
        }
      })
    },

    // 取消
    resetForm() {
      this.detailForm = {}
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },

  },

}
</script>
